/* dream-editorial CSS loader v1 */
(function(){try{if(document.getElementById('dream-editorial-css'))return;var s=document.currentScript||document.querySelector('script[src*="nsd-menu-features.js"]');if(!s)return;var m=(s.src||'').match(/^(.*\/assets\/)/);if(!m)return;var l=document.createElement('link');l.id='dream-editorial-css';l.rel='stylesheet';l.href=m[1]+'dream-editorial.css';document.head.appendChild(l);}catch(e){}})();
/* nsd-menu-features-1779020000
   Injects featured product/collection tiles into the right side of the header dropdown,
   filling the empty space with branded imagery and shortcuts. */
(function () {
  if (window.__nsdMenuFeaturesInit) return;
  window.__nsdMenuFeaturesInit = true;

  // Per-summary feature config. Key = lowercased summary text.
var FEATURE_MAP = {shop:[{kind:'tile',img:'https://cdn.shopify.com/s/files/1/0660/3397/5350/files/menu-best-sellers.jpg',title:'BEST SELLERS',alt:'Man seen from behind wearing a black t-shirt with large cream graphic text reading REACH OUT ANYWAY, walking down a city street',href:'/collections/best-sellers'},{kind:'tile',img:'https://cdn.shopify.com/s/files/1/0660/3397/5350/files/menu-recent-releases.jpg',title:'RECENT RELEASES',alt:'Man seen from behind wearing a black oversized hoodie with a rose and skeleton-hand graveyard graphic on the back',href:'/collections/recent-releases'}],collections:[{kind:'tile',img:'https://cdn.shopify.com/s/files/1/0660/3397/5350/files/TYPYLT_-_OS_Hoodie_-_Black_-_Front_8d026335-1f63-48e5-b901-6b5db03424b9_800x800.png',title:'TELL YOUR PEOPLE',alt:'Tell Your People You Love Them Black Oversized Hoodie, front view',href:'/collections/tell-your-people-you-love-them'},{kind:'tile',img:'https://cdn.shopify.com/s/files/1/0660/3397/5350/files/menu-nsd-legacy.jpg',title:'NSD LEGACY',alt:'Woman laughing outdoors in a desert campsite wearing a brown hoodie with \'You Are Bad For My Mental Health\' text',href:'/collections/legacy-collection'}]};

  function buildPanel(features) {
    var panel = document.createElement('div');
            panel.className = 'nsd-menu-feat-panel' + (features.length === 1 ? ' nsd-menu-feat-panel--single' : (features.length === 2 ? ' nsd-menu-feat-panel--pair' : ''));
    var inner = '';
    features.forEach(function (f) {
      if (f.kind === 'feature') {
        inner += '<a class="nsd-mfeat nsd-mfeat-large" href="' + f.href + '">'
          + (f.badge ? '<span class="nsd-mfeat-badge">' + f.badge + '</span>' : '')
          + '<img src="' + f.img + '" alt="' + f.title + '" loading="lazy" decoding="async">'
          + '<div class="nsd-mfeat-cap">'
          +   '<div class="nsd-mfeat-eyebrow">Featured</div>'
          +   '<div class="nsd-mfeat-title">' + f.title + '</div>'
          + (f.sub ? '<div class="nsd-mfeat-sub">' + f.sub + '</div>' : '')
          +   '<span class="nsd-mfeat-cta">' + (f.cta || 'Shop now') + ' <span class="nsd-mfeat-arr">\u2192</span></span>'
          + '</div>'
          + '</a>';
      } else {
        inner += '<a class="nsd-mfeat nsd-mfeat-tile" href="' + f.href + '">'
                    + '<img src="' + f.img + '" alt="' + (f.alt || f.title) + '" loading="lazy" decoding="async"' + (f.pos ? ' style="object-position:' + f.pos + '"' : '') + '>'
          + '<div class="nsd-mfeat-tcap"><span>' + f.title + '</span><span class="nsd-mfeat-arr">\u2192</span></div>'
          + '</a>';
      }
    });
    panel.innerHTML = inner;
    return panel;
  }

  function enhanceSubmenu(detailsEl) {
    if (!detailsEl || detailsEl.dataset.nsdMenuFeatured === '1') return;
    var summary = detailsEl.querySelector('summary');
    if (!summary) return;
    var key = (summary.innerText || '').trim().toLowerCase();
    var features = FEATURE_MAP[key];
    if (!features) return;
    var sub = detailsEl.querySelector('.header__submenu');
    if (!sub) return;
    detailsEl.dataset.nsdMenuFeatured = '1';

    // Wrap the existing <ul> in a "links column" so we can grid it
    var existingUl = sub.querySelector('ul');
    if (existingUl) {
      var col = document.createElement('div');
      col.className = 'nsd-menu-links-col';
      existingUl.parentNode.insertBefore(col, existingUl);
      col.appendChild(existingUl);
      // Add a column header
      var header = document.createElement('div');
      header.className = 'nsd-menu-col-header';
      header.textContent = 'Shop by category';
      col.insertBefore(header, existingUl);
    }
    var panel = buildPanel(features);
    sub.appendChild(panel);
    sub.classList.add('nsd-menu-enhanced');
  }

  function scanAndEnhance() {
    var allDetails = document.querySelectorAll('header details');
    allDetails.forEach(enhanceSubmenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndEnhance);
  } else {
    scanAndEnhance();
  }
  // Also observe for late header replacement (e.g., theme rerenders)
  var mo = new MutationObserver(function () {
    if (!document.querySelector('.nsd-menu-feat-panel')) scanAndEnhance();
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
